import React, { useState, useEffect } from "react";
import { Container, Row, Col, Card, Button, Form, Modal, InputGroup  } from "react-bootstrap";
import axios from "axios";
import { BASE_URL } from "../../../constants";
import "bootstrap/dist/css/bootstrap.min.css";
import "../../../CommonCSS/SocietyCSS.css";
import Select from 'react-select';
import EditPayVchrModal from './EditPayVchrModal';
import Print_Voucher from './Print_Voucher';
import CreatableSelect from "react-select/creatable";
import { common } from "@mui/material/colors";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const FinPaymentVoucher = () => {

  const [isEditable, setIsEditable] = useState(false);
  const [totDrAmt, setTotDrAmt] = useState("");
  const [totCrAmt, setTotCrAmt] = useState("");
  const [totAmtDiff, setTotAmtDiff] = useState("");
  const [showPrint, setShowPrint] = useState(false);
  const [budgLeftAmt, setBudgLeftAmt] = useState("");
  const [isEditMode, setIsEditMode] = useState(true);

  // Header data
  const [headerData, setHeaderData] = useState({
    fin_year1: "",
    trans_type: "PV",
    vchr_no: "",
    vchr_date: new Date().toISOString().split("T")[0],
    hdr_narration: "",
    chq_no: "",
    bank_name: "",
    payer_payee_name: "",
    bank_date: "",
    bgt_id: "",
    sub_bgt_id: "",
    sect_id: "",
    cb_code: "",
    hdr_amt: "",
    isBudEntryManual: false,
    isSubBudEntryManual: false
  });

   const [schoolDetails, setSchoolDetails] = useState({
    schoolName: "",
    schoolAddr1: "",
    schoolAddr2: "",
    schoolPhone1: "",
    logoPath: "",
    preparedBy: ""
  });

  // Dropdown data
  const [dropdowns, setDropdowns] = useState({
    budgetList: [],
    cbCodes: [],
  });

  const [subBudgetList, setSubBudgetList] = useState([]);
  const [acctCodes, setAcctCodes] = useState([]);
  const [ddlSections, setDdlSections] = useState([]);

  // const [isBudEntryManual, setIsBudEntryManual] = useState();
  // const [isSubBudEntryManual, setIsSubBudEntryManual] = useState();


  // Table rows
  const [detailRows, setDetailRows] = useState([
    { acct_code: "", acct_name: "", amount: "", drcr: "DR", narration: "" },
  ]);

  const [showsearchModal, setShowSearchModal] = useState(false);

  // Fetch dropdown lists
  useEffect(() => {
    const fetchDropdowns = async () => {
      try {
        const [AcctRes, CashBankRes, BudgetRes, SectionRes] =
          await Promise.all([
            axios.get(`${BASE_URL}/api/ddl_Accnt_Mast`),
            axios.get(`${BASE_URL}/api/ddl_CashBank_Mast`),
            axios.get(`${BASE_URL}/api/ddl_budget_master`),
            axios.get(`${BASE_URL}/api/ddl_sections`),
            //axios.get(`${BASE_URL}/api/get_SocietyDetails`),
          ]);

        setAcctCodes(AcctRes.data);

        setDropdowns({
          cbCodes: CashBankRes.data,
          budgetList: BudgetRes.data,
        });

        setDdlSections(SectionRes.data);

      } catch (err) {
        console.error("Dropdown fetch error:", err);
      }

    };

    fetchDropdowns();
  }, []);

  /// for fetching remaining budget amount
  useEffect(() => {

    const GetBudget_Left_Amt = async () => {

      setBudgLeftAmt(0);

      if (!headerData.isBudEntryManual && !headerData.isSubBudEntryManual &&
        headerData.bgt_id && headerData.sub_bgt_id && headerData.sect_id && headerData.vchr_date) {
        const res = await axios.get(
          `${BASE_URL}/api/get_bdgt_remain_amt`,
          {
            params: {
              p_Vchr_Date: headerData.vchr_date,
              p_Sect_Id: headerData.sect_id || 0,
              p_Bdgt_Id: headerData.bgt_id || 0,
              p_Sub_Bdgt_Id: headerData.sub_bgt_id || 0
            }
          }
        );
        if (res.data.length > 0) {
          let bdgt_rem_amt = res.data[0].bdgt_rem_amt;
          /// Start Currency format 
          let numericValue = parseFloat(bdgt_rem_amt.replace(/,/g, ""));
          if (isNaN(numericValue)) return;
          // Truncate to two decimals (no rounding)
          numericValue = Math.trunc(numericValue * 100) / 100;
          const formatted = new Intl.NumberFormat("en-IN", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          }).format(parseFloat(numericValue));
          setBudgLeftAmt(formatted);
          /// End Currency format 
        }
      }
    };

    GetBudget_Left_Amt();

  }, [
    headerData.bgt_id,
    headerData.sub_bgt_id,
    headerData.sect_id,
    headerData.vchr_date
  ]);

  // 🔹 Format helper (remove commas etc.)
  const parseNumber = (val) => {
    if (!val) return 0;
    return parseFloat(val.toString().replace(/,/g, "")) || 0;
  };

  // 🔹 Recalculate totals whenever details or header change
  useEffect(() => { // to Calculate Total Dr/Cr amounts

    let debitTotal = 0;
    let creditTotal = 0;
    let diffAmt = 0;

    detailRows.forEach((row) => {
      const amt = parseNumber(row.amount);
      if (row.drcr === "DR") debitTotal += amt;
      else creditTotal += amt;
    });

    // include header credit amount
    creditTotal += parseNumber(headerData.hdr_amt);
    diffAmt = debitTotal - creditTotal;

    const formatIndian = (num) =>
      num.toLocaleString("en-IN", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });

    setTotDrAmt(formatIndian(debitTotal));
    setTotCrAmt(formatIndian(creditTotal));
    setTotAmtDiff(formatIndian(diffAmt));

  }, [detailRows, headerData.hdr_amt]);

  const options = acctCodes.map(code => ({
    value: String(code.acct_code),
    label: code.acct_name
  })) || [];

  // Handle input change for header
  const handleHeaderChange = async (e) => {

    const { name, value } = e.target;
    setHeaderData((prev) => ({ ...prev, [name]: value }));

  };

  // Handle detail row change
  const handleDetailChange = (index, e) => {

    let { name, value } = e.target;

    if (name === 'amount') {
      value = value.replace(/,/g, "");
      // Allow only digits and at most one decimal point
      if (!/^\d*\.?\d*$/.test(value)) {
        return; // Ignore invalid input
      }
    }

    const updated = [...detailRows];
    updated[index][name] = value;
    setDetailRows(updated);

  };

  const handleDtlAmtBlur = (index, e) => {

    const { name, value } = e.target;

    if (value === "") return;

    // ✅ Convert to number and truncate instead of round
    let numericValue = parseFloat(value.replace(/,/g, ""));
    if (isNaN(value)) return;

    // Truncate to two decimals (no rounding)
    numericValue = Math.trunc(numericValue * 100) / 100;

    const formatted = new Intl.NumberFormat("en-IN", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(parseFloat(numericValue));

    const updated = [...detailRows];
    updated[index][name] = formatted;
    setDetailRows(updated);

  };

  const handleAccntChange = (index, selectedOption) => {

    const updated = [...detailRows];
    updated[index].acct_code = selectedOption ? selectedOption.value : "";
    updated[index].acct_name = selectedOption ? selectedOption.label : "";
    setDetailRows(updated);

  };

  const handleHdrAmtChange = (e) => {

    let value = e.target.value;

    // Remove commas before validating
    value = value.replace(/,/g, "");

    // Allow only digits and at most one decimal point
    if (!/^\d*\.?\d*$/.test(value)) {
      return; // Ignore invalid input
    }

    setHeaderData((prev) => ({ ...prev, 'hdr_amt': value }));

  };

  const handleBlur = () => {
    if (headerData.hdr_amt === "") return;

    // ✅ Convert to number and truncate instead of round
    let numericValue = parseFloat(headerData.hdr_amt.replace(/,/g, ""));
    if (isNaN(numericValue)) return;

    // Truncate to two decimals (no rounding)
    numericValue = Math.trunc(numericValue * 100) / 100;

    const formatted = new Intl.NumberFormat("en-IN", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(parseFloat(numericValue));

    //setAmount(formatted);
    setHeaderData((prev) => ({ ...prev, 'hdr_amt': formatted }));

  };

  // Add new row
  const addRow = () => {
    setDetailRows([...detailRows, { acct_code: "", acct_name: "", amount: "", drcr: "DR", narration: "" }]);
  };

  // Remove a detail row
  const removeRow = (index) => {
    const updated = [...detailRows];
    updated.splice(index, 1);
    setDetailRows(updated);
  };

  // Handle button actions
  const handleNew = () => {
    resetPage();
    setIsEditable(true);
    setIsEditMode(false);
  };

  const resetPage = () => {
    
    setHeaderData({
      fin_year1: "",
      trans_type: "PV",
      vchr_no: "",
      vchr_date: new Date().toISOString().split("T")[0],
      hdr_narration: "",
      chq_no: "",
      bank_name: "",
      payer_payee_name: "",
      bank_date: "",
      cc_id: "",
      bgt_id: "",
      sub_bgt_id: "",
      sect_id: "",
      cb_code: "",
      hdr_amt: "",
    });
    setDetailRows([{ acct_code: "", acct_name: "", amount: "", drcr: "DR", narration: "" }]);
    setIsEditMode(true);
  }

  const handleClear = () => {
    if (window.confirm("Sure you want to clear all data ?")) {
      resetPage();
      setIsEditable(false);
    }
  };

  // const handleEdit = () => {
  //   setIsEditable(true);
  // };

  const handleSave = async () => {

    if (!headerData.vchr_date || headerData.vchr_date === '') {
      toast.error('Please enter Voucher Date.');
      return;
    }

    if (!headerData.cb_code || headerData.cb_code === '') {
      toast.error('Please select Cash/Bank Account.');
      return;
    }

    if (!headerData.hdr_amt || headerData.hdr_amt === '0') {
      toast.error('Please enter Cash/Bank Amount.');
      return;
    }

    if (!headerData.hdr_narration || headerData.hdr_narration === '') {
      toast.error('Please enter Narration.');
      return;
    }

    if (!headerData.sect_id || headerData.sect_id === '') {
      toast.error('Please select Section.');
      return;
    }

    let lv_err_msg = '';

    for (let i = 0; i < detailRows.length; i++) {
      
        if (!detailRows[i].acct_code || detailRows[i].acct_code === '' )
        {
          lv_err_msg = 'Please select Account at Row # ' + (i + 1);
          break;
        }

        if (!detailRows[i].amount || detailRows[i].amount === '0' )
        {
          lv_err_msg = 'Please enter Amount at Row # ' + (i + 1);
          break;
        }

    }

    if (lv_err_msg) {
      toast.error(lv_err_msg);
      return;
    }

    let lv_dupl = 0;

    for (let i = 0; i < detailRows.length; i++) {

      for (let j = i + 1; j < detailRows.length; j++) {

        if (detailRows[i].acct_code === detailRows[j].acct_code) {
          lv_dupl = j;
          break;
        }
      }
      if (lv_dupl > 0) {
        break;
      }
    }

    if (lv_dupl > 0) {
       toast.error('Duplicate Account/Ledger selected at Row # ' + (lv_dupl + 1));
       return;
    }

    if ((parseNumber(totCrAmt) - parseNumber(totDrAmt)) !== 0) {
      toast.error('Debit and Credit Amounts are not tallying.');
      return;
    }

    const response = await axios.get(`${BASE_URL}/api/validate_vchr_date`, { 
      params: { p_VchrDate: headerData.vchr_date, p_Sect_Id: headerData.sect_id }, });

    if (response.data.length > 0) {
      if (response.data[0].fin_status === 'CLOSED' || response.data[0].fin_status === 'FISCAL') {
        toast.error('Voucher cannot be made in Closed or Fiscal year. Please check the Voucher Date.');
        return;
      }
    } else {
      toast.error('Finance Year not defined for the Voucher Date.');
      return;
    }

    const isConfirmed = window.confirm("Sure you want to save this record?");
    if (!isConfirmed) return;

    const payload = {
      header: headerData,
      details: detailRows,
    };

    try {
      const response = await axios.post(`${BASE_URL}/api/save_PayRcptVoucher`, payload);
      if (response.data.message !== '0') {
        setHeaderData((prev) => ({...prev, vchr_no: response.data.message}));
        toast.success(`Vocuher No ` + response.data.message + ` saved successfully`);
        const isPrint = window.confirm("Print Voucher ?");
        if (isPrint) {
          await Inst_Dtl_Vchr_Print();
          setShowPrint(true);
          // setTimeout(() => {
          //   resetPage();
          //   setIsEditable(false);
          // }, 3000);
        } else {
          setIsEditable(false);
          resetPage();
        }

      }
    } catch (err) {
      console.error("Save error:", err);
      toast.error("Failed to Voucher. Please check input!");
    }
  };

  const handleVchrRowSelect = async (selRow) => {

    setShowSearchModal(false);

    const response = await axios.get(`${BASE_URL}/api/get_Vchr_ById`, {
            params: {p_Sect_Id: selRow.sect_id, p_FinYear1: selRow.fin_year1, p_VchrNo: selRow.vchr_no, p_TransType: 'PV'},
          });

    headerData.vchr_no = selRow.vchr_no;
    headerData.trans_type = 'PV';
    headerData.fin_year1 = selRow.fin_year1;
    headerData.vchr_date = response.data[0].vchr_date;
    headerData.cb_code = response.data[0].cb_code;
    headerData.hdr_amt = response.data[0].amount;
//    headerData.cc_id = response.data[0].cc_id;
    headerData.bgt_id = response.data[0].bgt_id;

    if (response.data[0].bgt_id) {
      const res = await axios.get(`${BASE_URL}/api/ddl_sub_budget_master`, { params: { p_Bdgt_Id: response.data[0].bgt_id } });
      setSubBudgetList(res.data);
      headerData.sub_bgt_id = response.data[0].sub_bgt_id;
    }

    headerData.sect_id = response.data[0].sect_id;
    headerData.bank_name = response.data[0].bank_name;
    headerData.payer_payee_name = response.data[0].payer_payee_name;
    headerData.chq_no = response.data[0].chq_no;
    headerData.hdr_narration = response.data[0].narration;
    handleBlur();

    const detailRows = response.data.filter(row => Number(row.acct_code) > 0);

    if (detailRows.length > 0) {
      setDetailRows(detailRows);
    }

    for (let i = 0; i < detailRows.length; i++) {

      const formatted = new Intl.NumberFormat("en-IN", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(parseFloat(detailRows[i].amount));

      const updated = [...detailRows];
      updated[i]["amount"] = formatted;

      setDetailRows(updated);

    }

    Inst_Dtl_Vchr_Print();

    setIsEditable(true);
    // setIsLocked(true);
    setIsEditMode(true);

  };

  // Institution Details to print Vocuher Header
  const Inst_Dtl_Vchr_Print = async () => {

    try {

      const response = await axios.get(`${BASE_URL}/api/get_inst_vchr_print`, {
        params: { p_Sect_Id: headerData.sect_id, p_vchr_no: headerData.vchr_no }
      });

      if (response.data.length > 0) {
        setSchoolDetails({
          schoolName: response.data[0].school_name,
          sectionName: response.data[0].section_name,
          schoolAddr1: response.data[0].addr_1,
          schoolPhone1: response.data[0].tel_no,
          logoPath: response.data[0].logo_path,
          preparedBy: response.data[0].user_name
        });
      }

      return true;

    } catch (err) {
      console.error(err);
      return false;
    }

  };

  const budgetOptions = dropdowns.budgetList.map(sb => ({
    value: sb.bgt_id,
    label: sb.bgt_name
  }));

  const subBudgetOptions = subBudgetList.map(sb => ({
    value: sb.sub_bgt_id,
    label: sb.sub_bgt_name
  }));

  return (
    <Container fluid className="p-3">
      {/* Header */}
      <Card className="p-3 mb-4">
        <Row className="mb-3">
          <Col md={2}>
            <Form.Label>Voucher No</Form.Label>
            <Form.Control style={{textAlign: 'right'}} type="text" name="vchr_no"
              className="form-control" value={headerData.vchr_no} disabled />
          </Col>
          <Col md={2}>
            <Form.Label>Voucher Date</Form.Label>
            <Form.Control type="date" name="vchr_date" className="form-control"
              value={headerData.vchr_date} onChange={handleHeaderChange} disabled={!isEditable} />
          </Col>

          <Col md={6}>
            <Form.Label>Cash/Bank A/c</Form.Label>
            <Form.Select className="form-select" name="cb_code" value={headerData.cb_code} 
              onChange={handleHeaderChange} disabled={!isEditable} >
              <option value="">-- Select Cash/Bank --</option>
              {dropdowns.cbCodes.map((cb) => (
                <option key={cb.cb_code} value={cb.cb_code}>
                  {cb.cb_name}
                </option>
              ))}
            </Form.Select>
          </Col>

          <Col md={2} className="text-end">
            <Form.Label>Amount</Form.Label>
            <InputGroup>
            <Form.Control 
              type="text" name="hdr_amt" className="form-control text-end"
              value={headerData.hdr_amt} onChange={handleHdrAmtChange} onBlur={handleBlur}
              disabled={!isEditable} />
              <InputGroup.Text style={{ width: "40px" }}>Cr</InputGroup.Text>
              {/* , background: 'orange' */}
              </InputGroup>
          </Col>

        </Row>

        <Row className="mb-3">
          {/* <Col md={2}>
            <Form.Label>Cost Center</Form.Label>
            <Form.Select name="cc_id" value={headerData.cc_id}
              onChange={handleHeaderChange} disabled={!isEditable} >
              <option value="">-- Select Cost Center -- </option>
              {dropdowns.commonList.filter(c => c.comm_type === 'COSTCENT').map(c => (
                <option key={c.irn} value={c.irn}>{c.type_desc}</option>
              ))}
            </Form.Select>
          </Col> */}

          {/* <Col md={3}>
            <Form.Label>Bank Name</Form.Label>
            <Form.Control
              type="text"
              name="bank_name"
              className="form-control"
              value={headerData.bank_name}
              onChange={handleHeaderChange}
              disabled={!isEditable}
            />
          </Col> */}

          <Col md={3}>
            <Form.Label>Section</Form.Label>
            <Form.Select
              className="form-select"
              name="sect_id"
              value={headerData.sect_id}
              onChange={handleHeaderChange}
              disabled={isEditMode}
            >
              <option value="">-- Select Section --</option>
              {ddlSections.map(sec => (
                <option key={sec.section_id} value={sec.section_id}>{sec.section_desc}</option>
              ))}
            </Form.Select>
          </Col>

          <Col md={2}>
            <Form.Label>Cheque No</Form.Label>
            <Form.Control
              type="text"
              name="chq_no"
              className="form-control"
              value={headerData.chq_no}
              onChange={handleHeaderChange}
              disabled={!isEditable}
            />
          </Col>

          <Col md={3}>
            <Form.Label>Payee Name</Form.Label>
            <Form.Control
              type="text"
              name="payer_payee_name"
              className="form-control"
              value={headerData.payer_payee_name}
              onChange={handleHeaderChange}
              disabled={!isEditable}
            />
          </Col>

          <Col md={4}>
            <Form.Label>Narration</Form.Label>
            <Form.Control 
              type="text"
              name="hdr_narration"
              className="form-control"
              value={headerData.hdr_narration}
              onChange={handleHeaderChange}
              disabled={!isEditable}/>
          </Col>

        </Row>

        <Row className="mb-3">
          {/* <Col md={2}>
            <Form.Label>Cost Center</Form.Label>
            <Form.Select name="cc_id" value={headerData.cc_id}
              onChange={handleHeaderChange} disabled={!isEditable} >
              <option value="">-- Select Cost Center -- </option>
              {dropdowns.commonList.filter(c => c.comm_type === 'COSTCENT').map(c => (
                <option key={c.irn} value={c.irn}>{c.type_desc}</option>
              ))}
            </Form.Select>
          </Col> */}
          <Col md={5}>
            <Form.Label>Budget Code</Form.Label>

            <CreatableSelect
              isDisabled={!isEditable}
              placeholder="-- Select Budget --"
              options={budgetOptions}
              value={
                budgetOptions.find(
                  option => option.value === headerData.bgt_id
                ) || (
                  headerData.bgt_id
                    ? {
                      value: headerData.bgt_id,
                      label: headerData.bgt_id
                    }
                    : null
                )
              }
              onChange={async (selectedOption) => {

                const isManual = !!selectedOption?.__isNew__;

                // update state
                setHeaderData(prev => ({
                  ...prev,
                  bgt_id: selectedOption?.value || "",
                  sub_bgt_id: "",
                  isBudEntryManual: isManual
                }));

                // clear existing sub budget list
                setSubBudgetList([]);

                // if typed manually OR cleared => do not call API
                if (isManual || !selectedOption?.value) {
                  return;
                }

                try {
                  const res = await axios.get(
                    `${BASE_URL}/api/ddl_sub_budget_master`,
                    {
                      params: {
                        p_Bdgt_Id: selectedOption.value
                      }
                    }
                  );

                  setSubBudgetList(res.data);

                } catch (err) {
                  console.error("Error loading sub budgets:", err);
                }
              }}
              isClearable
            />

          </Col>

          <Col md={4}>
            <Form.Label>Sub-Budget Code</Form.Label>

            <CreatableSelect
              isDisabled={!isEditable}
              placeholder="-- Select Sub-Budget --"
              options={subBudgetOptions}

              value={
                subBudgetOptions.find(
                  option => option.value === headerData.sub_bgt_id
                ) || (
                  headerData.sub_bgt_id
                    ? {
                      value: headerData.sub_bgt_id,
                      label: headerData.sub_bgt_id
                    }
                    : null
                )
              }

              onChange={(selectedOption) => {
                setHeaderData(prev => ({
                  ...prev,
                  sub_bgt_id: selectedOption?.value || "",
                  isSubBudEntryManual: !!selectedOption?.__isNew__
                }));
                //GetBudget_Left_Amt();

              }}

              isClearable
            />
          </Col>

          <Col md={3} className="text-end">
            <Form.Label>Budget Remaining Amt</Form.Label>
            <Form.Control className="form-control text-end"
              type="text"
              name="budgLeftAmt"
              value={budgLeftAmt}
              disabled/>
          </Col>

        </Row>

        <Row className="mb-3">

          <Col md={12} className="d-flex justify-content-end">
            <Button style={{height: '40px', marginTop: '10px', width: '130px'}} className="me-2" variant="primary" 
                  disabled={isEditable} onClick={handleNew}>New </Button>
            <Button style={{height: '40px', marginTop: '10px', width: '130px'}} className="me-2" variant="warning"
                   disabled={isEditable} onClick={(e) => (setShowSearchModal(true))}>Edit </Button>
            {showsearchModal && (
              <EditPayVchrModal
                show={showsearchModal}
                handleClose={() => setShowSearchModal(false)}
                onRowSelect={handleVchrRowSelect} />
            )}
            <Button style={{height: '40px', marginTop: '10px', width: '130px'}} className="me-2" variant="secondary" 
              disabled={!isEditable} onClick={handleClear}>Clear</Button>
            <Button style={{ height: '40px', marginTop: '10px', width: '130px' }} className="me-2" variant="success"
              disabled={!isEditable} onClick={handleSave}>Save</Button>
            <Button style={{ height: "40px", marginTop: "10px", width: "130px" }}
              className="me-2" variant="info" disabled={!isEditable}
              onClick={() => setShowPrint(true)} >Print </Button>
            {showPrint && (
              <Modal show={showPrint} onHide={() => setShowPrint(false)} size="lg">
                <Modal.Header closeButton>
                  <Modal.Title>Print Voucher</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <Print_Voucher
                    schoolDetails={schoolDetails}
                    headerData={headerData} detailRows={detailRows}
                    onAfterPrint={() => {
                      setTimeout(() => {
                        setShowPrint(false);
                        resetPage();
                        setIsEditable(false);
                      }, 1000);
                    }} 
                    />
                </Modal.Body>
              </Modal>
            )}
          </Col>
          
        </Row>

      </Card>

      {/* Details Table */}
      <Card className="p-3">
        <div style={{ minHeight: '220px' }} className="table-wrapper">
          <table style={{ maxHeight: '35px' }} className="responsive-table scty-custom-table">
            <thead>
              <tr>
                <th style={{width: '5%', textAlign: 'center'}}>#</th>
                <th style={{width: '50%', textAlign: 'left'}}>Account/Ledger Name</th>
                <th style={{width: '15%', textAlign: 'right'}}>Amount</th>
                <th style={{width: '10%', textAlign: 'left'}}>Dr/Cr</th>
                {/* <th>Narration</th> */}
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {detailRows.map((row, index) => (
                <tr key={index}>
                  <td style={{ width: "5%", textAlign: 'center' }}>{index + 1}</td>
                  <td>
                    <Select name="acct_code"
                      options={options}
                      value={options.find(option => String(option.value) === String(row.acct_code)) || null}
                      onChange={(selectedOption) => handleAccntChange(index, selectedOption)}
                      isDisabled={!isEditable} placeholder="-- Select Account --"
                      menuPortalTarget={document.body}
                      styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                    />

                  </td>
                  <td>
                    <input type="text" name="amount" className="form-control text-end"
                      value={row.amount} 
                      onChange={(e) => handleDetailChange(index, e)}
                      onBlur={(e) => handleDtlAmtBlur(index, e)}
                      disabled={!isEditable} min="0" />
                  </td>
                  <td>
                    <select className="form-select" name="drcr" value={row.drcr}
                      onChange={(e) => handleDetailChange(index, e)} disabled={!isEditable} >
                      <option value="DR">Dr</option>
                      <option value="CR">Cr</option>
                    </select>
                  </td>
                  {/* <td>
                    <input
                      type="text"
                      name="narration"
                      className="form-control"
                      value={row.narration}
                      onChange={(e) => handleDetailChange(index, e)}
                      disabled={!isEditable}
                    />
                  </td> */}
                  <td>
                    {detailRows.length > 1 && (
                      <Button size="sm" variant="danger" onClick={() => removeRow(index)}
                        disabled={!isEditable} >Delete </Button>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className="d-flex justify-content-between align-items-center mb-3" style={{marginTop: '10px'}}>
          <div className="d-flex gap-2">
            <InputGroup style={{ width: "300px" }}>
              <InputGroup.Text style={{ width: "110px", background: "lightblue", color: "black" }}>Total Dr Amt</InputGroup.Text>
              <input type="text" name="totDrAmt" className="form-control text-end"
                value={totDrAmt} disabled min="0" />
            </InputGroup>
            <InputGroup style={{ width: "300px" }}>
              <InputGroup.Text style={{ width: "110px", background: "lightblue", color: "black" }}>Total Cr Amt</InputGroup.Text>
              <Form.Control type="text" name="totCrAmt" className="form-control text-end"
                value={totCrAmt} disabled min="0" />
            </InputGroup>
            <InputGroup style={{ width: "300px" }}>
              <InputGroup.Text style={{ width: "110px", background: "orange", color: "black" }}>Difference</InputGroup.Text>
              <Form.Control type="text" name="totAmtDiff" className="form-control text-end"
                value={totAmtDiff} disabled min="0" />
            </InputGroup>
          </div>
          <div className="d-flex gap-2">
              <Button variant="primary" onClick={addRow} disabled={!isEditable}> Add Row </Button>
          </div>
        </div>
      </Card>
    </Container>
  );
};

export default FinPaymentVoucher;
